import { Subject } from 'rxjs';
export class QueueingSubject extends Subject {
  constructor() {
    super(...arguments);
    this.queuedValues = [];
  }
  next(value) {
    if (this.closed || this.observed) super.next(value);else this.queuedValues.push(value);
  }
  subscribe(observerOrNext, error, complete) {
    if (observerOrNext == null) {
      return super.subscribe(null, error, complete);
    } else {
      const subscription = typeof observerOrNext === 'function' ? super.subscribe(observerOrNext, error, complete) : super.subscribe(observerOrNext);
      if (this.queuedValues.length) {
        this.queuedValues.forEach(value => super.next(value));
        this.queuedValues.splice(0);
      }
      return subscription;
    }
  }
}
